import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";

/**
 * The policies a picker may offer. A milestone policy stays listed only while
 * its flag is on, unless the caller shows existing schedules and needs every
 * policy's name.
 */
export function selectAvailableScheduleTemplates(options: {
    templates: ScheduleTemplateListItem[];
    isMilestoneEnabled: boolean;
    includeMilestone: boolean;
}): ScheduleTemplateListItem[] {
    if (options.isMilestoneEnabled || options.includeMilestone) {
        return options.templates;
    }
    return options.templates.filter((template) => !template.isMilestone);
}
